const checkIsExternalUrl = (url) => url && !url.startsWith('/') && !url.startsWith('#')

export default checkIsExternalUrl
